import axios from "axios";
import { getToken, getUser } from "../Utils/Common";
import token_valid from "./TokenValid";

//get import data with pagination
const getWarehouseData = async (offset, pageSize, filter) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/warehouse/all/" +
          offset +
          "/" +
          pageSize,
        {
          name: filter._name ? filter._name.trim() : null,
          barcode: filter._type ? filter._type.trim() : null,
          isActive: filter._isActive ? filter._isActive.trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch(async (error) => {
        // return "Something went wrong...";
        console.log("get Warehouses " + error);
        return "Something went wrong...";
      });
  }
};

//add warehouse
const addWarehouse = async (values) => {
  console.log(values);
  // check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/warehouse/add",
        {
          name: values._name,
          type: values._type,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        // setUserSession(response.data.token, response.data.user)
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get warehouse " + error);
        return false;
      });
  }
};

//add Sales people to warehouse
const addPeopleToWarehouse = async (values) => {
  console.log(values);
  // check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .post(process.env.REACT_APP_API_URL + "/api/warehouse/add/user", values, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then(async (response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get update warehouse " + error);
        return false;
      });
  }
};

//get warehouse types
const getWarehouseTypes = async () => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/warehouse/types", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Warehouse Types " + error);
        return "Something went wrong...";
      });
  }
};

//get warehouses by Type
const getWarehousesByType = async (type) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/warehouse/type/" + type, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Warehouses by type " + error);
        return "Something went wrong...";
      });
  }
};

//get warehouse by Id
const getWarehouseById = async (warehouseId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/warehouse/" + warehouseId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Warehouse by Id " + error);
        return "Something went wrong...";
      });
  }
};

export {
  getWarehouseData,
  addWarehouse,
  getWarehouseTypes,
  getWarehousesByType,
  getWarehouseById,
  addPeopleToWarehouse,
};
